import { Button, MenuItem, MenuList, Popover } from '@material-ui/core';
import * as React from 'react';

import { EditorApi } from 'react-text-editor';

interface EmailSequenceFormVariablesProps {
    variables: string[];
    editorRef: React.RefObject<EditorApi>;
}

const getVariableHtml = (variable: string) => {
    if (variable === '{{Phone Call Scheduling Link}}') {
        return '<a href="{{Phone Call Scheduling Link}}">{{Phone Call Scheduling Link Text}}</a>';
    } else if (variable === '{{atsLink}}' || variable === '{{personLinkedin}}') {
        return `<a href="${variable}">${variable}</a>`;
    } else if (variable === '{{primaryEmail}}') {
        return '<a href="mailto:{{primaryEmail}}">{{primaryEmail}}</a>';
    } else if (variable === '{{phoneCallSchedulingLink}}') {
        return '<a href="{{phoneCallSchedulingLink}}">{{phoneCallSchedulingLinkText}}</a>';
    } else {
        return variable;
    }
};

export const EmailSequenceFormVariables: React.FC<EmailSequenceFormVariablesProps> = ({ variables, editorRef }) => {
    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClosePopover = () => {
        setPopoverOpen(false);
    };

    const handleOpenPopover = (e: React.MouseEvent) => {
        e.preventDefault();
        setAnchorEl(e.currentTarget);
        setPopoverOpen(true);
    };

    const handleInsertVariable = (variable: string) => (e: React.MouseEvent) => {
        e.preventDefault();
        editorRef.current?.insertContent(getVariableHtml(variable));
        setPopoverOpen(false);
    };

    const menuItems = variables.map((v) => {
        return (
            <MenuItem key={v} onClick={handleInsertVariable(v)}>
                {v}
            </MenuItem>
        );
    });
    const popover = (
        <Popover
            open={popoverOpen}
            onClose={handleClosePopover}
            anchorEl={anchorEl}
            transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        >
            <MenuList>{menuItems}</MenuList>
        </Popover>
    );

    return (
        <React.Fragment>
            <Button onClick={handleOpenPopover} disabled={!editorRef}>
                Personalize
            </Button>
            {popover}
        </React.Fragment>
    );
};
